// extracted by mini-css-extract-plugin
export var measureBox = "_cg-0";